import React from "react";
import LoginEmailForm from "./LoginEmailForm";
import { LoginModes } from "./loginSlice";
import { LeftPanel, MainContainer, RightPanel } from "./LoginLayout";
import { StackPanelLogo } from "./StackCarePanelLogo";
import AccountManagementHeader from "./AccountManagementHeader";
import LeftPanelFooter from "./LeftPanelFooter";

/**
 * Login component
 */
export default function Login() {
  return (
    <MainContainer>
      <LeftPanel>
        <StackPanelLogo />
        <AccountManagementHeader />
        <LeftPanelFooter />
      </LeftPanel>
      <RightPanel>{<LoginEmailForm mode={LoginModes.LOGIN} />}</RightPanel>
    </MainContainer>
  );
}
